import {
  Form,
  Button,
  Col,
  Container,
  InputGroup,
  Row,
  Alert,
  Card,
  CardHeader,
  CardBody,
} from "react-bootstrap";
import StripeTestPanel from "../components/stripeTestPanel";
import React, { useEffect, useRef, useState } from "react";
import { loadAuth } from "../libs/authMgmt";
import { getIfCardUnavailable } from "../libs/countryData";
import CustomPaymentOptionsManager from "../components/settings/paymentOptions";
import EMenuManager from "../components/settings/eMenuManager";
import Header from "../components/globals/headers/header";
import SubHeader from "../components/globals/headers/subHeader";

export default function PaymentSettings() {

  const [headerWidth, setHeaderWidth] = useState(0);
  const elementRef = useRef(null);
  useEffect(() => {
    if (elementRef.current) {
      setHeaderWidth(elementRef.current.clientWidth - 10);
      console.log("Header width:", elementRef.current.clientWidth);
    }
  }, []);

  return (
    <>
      <Container fluid className="settings_cont">
        {/* <Row>
          <Col>
            <h1 className="section_title">Payment Settings</h1>
            <hr className="my-2" />
          </Col>
        </Row> */}
        <Row>
          <Col>

            <h3 className="mt-3">Payouts</h3>
            {getIfCardUnavailable() ? (
              <Alert variant="warning">
                Card payments and payouts are currently not available for
                your country. Only Cash option available.
              </Alert>
            ) : (
              <StripeTestPanel
                priceIds={[
                  // { name: "Starter", id: "price_1S22LAJwuZgO17bKPYaPs4Bg" },
                  { name: "Pro", id: "price_1SSXXOJwuZgO17bKk4LALVIp" },
                ]}
              />
            )}
            {/* <hr />
            <Row>
               <Col>
                  <h3 className="mt-3">E-Menu</h3>
                  <EMenuManager />
              </Col> 
            </Row> */}
          </Col>
            <Col>
                <h3 className="mt-3">Other Payment Methods</h3>
                  {
                    loadAuth("company")?.plan === "pro" ? <CustomPaymentOptionsManager /> : <>
                      <p className="text-secondary">
                        Manage custom payment methods for your company.
                      </p>
                      <Alert variant="danger">This is a Pro feature</Alert>
                      </>
                  }
            </Col>
        </Row>
      </Container>
    </>
  );
}
